import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';
import Image from 'next/image';
import useMoshUrl from 'src/hooks/useMoshUrl';
import countries, { displayCountry, isCountry } from 'src/constants/Countries';
import MoshyLogo from '../MoshyLogo/MoshyLogo';
import { moshyProdAuBaseUrl, moshyProdNzBaseUrl } from 'src/constants/Routes';

const list = [
    {
        label: 'Mosh',
        image: '/images/home/footer/mosh-icon.png',
        titleImage: {
            src: '/images/home/footer/mosh-title.png',
            width: 64,
            height: 30,
            alt: 'label',
        },
        text: 'Visit getmosh.com.au',
        url: undefined,
    },
    {
        label: 'THM',
        image: '/images/home/footer/thm-icon.png',
        titleImage: {
            src: '/images/home/footer/thm-title.png',
            width: 113,
            height: 34,
            alt: 'label',
        },
        text: 'Visit www.healthymummy.com',
        url: 'https://www.healthymummy.com/?utm_source=Moshy&utm_medium=Moshy-footer&utm_campaign=our-brands',
    },
] as const;

export default function MoshyLogoLink() {
    const moshUrl = useMoshUrl(
        'Moshy',
        'website-footer',
        'Moshy_Website_Footer-Mosh',
        'mosh-footer-banner',
        'male-dedicated-brand-mosh',
    );

    return (
        <section>
            {isCountry('AU') && (
                <>
                    <div className="mt-6 font-semibold">Our brands</div>
                    <div className="xl:flex xl:gap-2">
                        {list.map((item, index) => (
                            <a
                                className="flex xl:w-fit"
                                key={index}
                                title={item.label}
                                href={item.url ?? moshUrl}
                                target="_blank"
                            >
                                <div className="mt-2 flex rounded-2xl bg-blue-extra-dark shadow-[0_5px_20px_-10px_rgba(19,40,18,0.1)] max-sm:w-[100%] xl:w-fit">
                                    <Image
                                        className="m-4 object-contain"
                                        src={item.image}
                                        width={52}
                                        height={52}
                                        alt={item.label}
                                    />
                                    <div className="my-4 max-sm:w-[60%]">
                                        <Image
                                            className="h-[30px] object-contain"
                                            src={item.titleImage.src}
                                            width={item.titleImage.width}
                                            height={item.titleImage.height}
                                            alt={item.label}
                                        />
                                        <div className="font-normal mt-1 font-body text-xs leading-[135%] text-grey-200">
                                            {item.text}
                                        </div>
                                    </div>
                                    <div className="flex items-center p-4">
                                        <FontAwesomeIcon
                                            icon={faArrowUpRightFromSquare}
                                        />
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>
                </>
            )}
            <div className="mt-6 font-semibold">
                Based in {isCountry('AU') ? countries.NZ : countries.AU}?
            </div>
            <a
                className="flex xl:w-fit"
                href={isCountry('AU') ? moshyProdNzBaseUrl : moshyProdAuBaseUrl}
                target="_blank"
            >
                <div className="mt-2 flex rounded-2xl bg-blue-extra-dark shadow-[0_5px_20px_-10px_rgba(19,40,18,0.1)] max-sm:w-[100%] xl:w-fit">
                    <Image
                        className="m-4 object-contain"
                        src={
                            isCountry('AU')
                                ? '/images/home/footer/new-zealand-flag.svg'
                                : '/images/home/footer/australia-flag.svg'
                        }
                        width={52}
                        height={39}
                        alt={`${displayCountry} flag`}
                    />
                    <div className="my-4 max-sm:w-[60%]">
                        <MoshyLogo variant="white" />
                        <div className="font-normal mt-1 font-body text-xs leading-[135%] text-grey-200">
                            {isCountry('AU')
                                ? 'Visit moshy.co.nz'
                                : 'Visit getmoshy.com.au'}
                        </div>
                    </div>
                    <div className="flex items-center p-4">
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                    </div>
                </div>
            </a>
        </section>
    );
}
